import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/repo/global-music-ssr/src/app/artist/[id]/component/list.tsx");
